var defId = 1;

export default function definitionId() {
    return "kdef" + defId++;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/definition-id.js
// module id = 1330
// module chunks = 0